
import { useState } from 'react';
import LoadingButton from './LoadingButton';
import { httpGetBinary as httpGetBinaryDownload } from '../../modules/Backend';
import HttpStatusCodes from '../../modules/HttpStatusCodes';
import iconDownload from "../../assets/icons/icon-download.svg";

export interface IFileDownloadWidgetProps {
  id: string;
  entityName: string;
  onBeforeDownload?: Function | undefined,
  buttonText?: string;
  loadingText?: string;
  className?: string;
  queryParamName?: string;
}
const FileDownloadWidget = ({ id, entityName, onBeforeDownload, buttonText, loadingText, className, queryParamName = "id" }: IFileDownloadWidgetProps) => {

  const [downloading, setDownloading] = useState(false);

  const download = async () => {
    if (!id || !entityName) return;
    setDownloading(true);

    try {
      if (onBeforeDownload) {
        await onBeforeDownload();
      }
      const response = await httpGetBinaryDownload(`api/${entityName}/getForDownload?${queryParamName}=${id}`);
      if (response.status === HttpStatusCodes.Ok) {
        const blob = response.data;

        // Extract filename from headers (case-insensitive)
        let fileName = "download.csv";
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match?.[1]) {
            fileName = match[1].replace(/['"]/g, "");
          }
        }

        // Trigger download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Download failed", error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className={`display--flex gap--s justifyContent--center ${className || ''}`}>
      <LoadingButton
        buttonText={buttonText || 'Download'}
        loadingText={loadingText ?? ''} // If we set loading text it will increase the button size which looks awful in adobe aria lists as the table will resize
        isDisabled={downloading}
        isLoading={downloading}
        className='button button--small button--secondary button--with-icon'
        onPress={download}
      >
        <img src={iconDownload} />
      </LoadingButton>
    </div>
  );
};

export default FileDownloadWidget;